import { Capacitor } from '@capacitor/core';
import deviceService from '../device/deviceService';
import pushNotificationService from '../pushNotifications/pushNotificationService';

/**
 * Native bootstrap - poziva se jednom iz `src/index.js`, pre React render-a.
 *
 * Redosled je važan za cold start: push listeneri se registruju što ranije
 * kako tap na notifikaciju koji je pokrenuo aplikaciju ne bi bio izgubljen.
 * Navigacija se izvršava kasnije, kada auth i router budu spremni.
 *
 * Web: potpuni no-op (nijedan native API se ne poziva).
 *
 * @returns {boolean} True ako je aplikacija native
 */
export const initializeNativeServices = () => {
  if (!Capacitor.isNativePlatform()) return false;

  // DeviceId se generiše/čita odmah, da bi login mogao da ga pošalje.
  deviceService.initialize().catch(() => {});

  // Listeneri moraju postojati pre nego što se React mountuje.
  pushNotificationService.initializeListeners().catch(() => {});

  return true;
};

export default initializeNativeServices;
